import axios from "axios";
import URLPage from "../endPoints/endpoints";

function  getVanlist (from, limit, token) {

return axios.get(`${URLPage}/api/van?from=${from}&limit=${limit}`, {
        headers: {
            'x-token': token
        }
    })
   
 

}

export default getVanlist